﻿namespace eXpress.web.shoppingcart {
	window.addEventListener('load', () => {
		const pageLogComponent = components.main.createPageLog(html.querySelector<HTMLElement>(document, '.technical-top-message-log', true));
		let popupConfirmDeleteIsOpen = false;
		let gtmData: string | undefined = window.gtmData;

		const loginComponent = eXpress.core.WatchLogin();
		loginComponent.start();

		const refreshMiniBasket = () => {
			return actions();
		};

		const changePromoCode = (changePromoCode: string) => {
			return actions(changePromoCode);
		};

		const deleteCartProduct = (id: string) => {
			return actions(undefined, id);
		};

		const actions = (changePromoCode?: string, deleteCartItemId?: string, updateQuantityCartItemId?: string, updateQuantity?: number) => {
			return $.ajax({
				url: "/ajaxxhr/Cart/CartUxActions",
				type: "POST",
				cache: false,
				data: {
					changePromoCode,
					deleteCartItemId,
					updateQuantityCartItemId,
					updateQuantity
				}
			})
				.then(res => {
					const result = res as eXpress.components.checkout.ICartUxActionResult;

					if (result.RestartNeeded) {
						document.location.href = "?restart=true";
						return $.Deferred().reject(result).promise();
					} else {
						if (res.ConfirmationMessage) {
							pageLogComponent.updateMessageAndStyle(eXpress.components.main.PageLogStyle.Success, res.ConfirmationMessage);
						} else {
							if (pageLogComponent) pageLogComponent.hide();
						}

						const nextButtons = html.querySelectorAll<HTMLElement>(document, ".technical-checkout-step-confirm-button");
						if (res.InvalidMinimumMessage && !res.ConfirmationMessage) {
							nextButtons.forEach(nextButton => nextButton.dataset['productminimum'] = res.InvalidMinimumMessage);
							pageLogComponent.updateMessageAndStyle(components.main.PageLogStyle.Error, res.InvalidMinimumMessage);
						}

						if (res.InvalidMaximumMessage && !res.ConfirmationMessage) {
							nextButtons.forEach(nextButton => nextButton.dataset['productmaximum'] = res.InvalidMaximumMessage);
							pageLogComponent.updateMessageAndStyle(components.main.PageLogStyle.Error, res.InvalidMaximumMessage);
						}

						if (!res.InvalidMinimumMessage)
							nextButtons.forEach(nextButton => nextButton.removeAttribute("data-productminimum"));

						if (!res.InvalidMaximumMessage)
							nextButtons.forEach(nextButton => nextButton.removeAttribute("data-productmaximum"));

						gtmData = result.GtmData;
						return result;
					}
				});
		};

		const sliderComponents: { key: string, slider: components.main.ICustomSlider }[] = [];
		const previewPopup = (cartItemId: string, editUrl: string) => {
			let dialog: core.StyleguideViewPopup;

			const dialogId = `preview-${cartItemId}`;
			utils.showLoadingDialog(eXpress.core.StyleguideViewPopup.createDialogAsync(
				{
					view: "StyleGuidePreviewDialog",
					dialogId: dialogId,
					forceRefresh: false
				}, {
				cartItemId: cartItemId,
				editUrl: editUrl
			})
				.then($popup => {
					if (!$popup[0]) {
						// error server side => restart the cart
						document.location.href = "?restart=true";
					}

					dialog = new core.StyleguideViewPopup($popup, {
						closeEvent: () => {
							// reset slider to the first item
							const customSliderComponent = sliderComponents.find(x => x.key === dialogId);
							customSliderComponent && customSliderComponent.slider.JumpIntoView(customSliderComponent.slider.Settings.sliderElements[0]);
						}
					});
					const slider = html.querySelector<HTMLElement>($popup[0], '.technical-slider', false);

					if (!slider) {
						// slider already initialized && events binded
						dialog.openAsync();
						return;
					}

					const sliderElements: eXpress.components.main.ICustomPhotoSliderItem[] = [];
					for (let z = 0, l = slider.children.length; z < l; z++)
						sliderElements.push({ template: slider.children[z] as HTMLElement });

					const sliderSettings = {
						sliderElements: sliderElements,
						sliderContainerSettings: {
							extraSliderClass: 'm-carrousel__slider',
							cssWhenButtonsBothOnMax: 'u-hide',
							elementsContainerSettings: {
								extraSliderClass: 'm-carrousel__slider-elements',
								slideClicked: () => { return; }
							},
							nextButton: {
								cssWhenOnMax: 'a-button--disabled',
								onClick: () => { return; }
							},
							previousButton: {
								cssWhenOnMax: 'a-button--disabled',
								onClick: () => { return; }
							},
						},
						showHalfSlides: false,
						replaceWithElement: true,
						enableEternalSliding: true,
						resize1SlideToFullWidth: true,
						eternalSlidingMode: eXpress.components.main.EternalSlidingMode.Infinite,
						translateForMovement: true,

						InitializedEvent: (settings, sliderEl) => {
							sliderEl.classList.add('m-carrousel__slider--initialized');
							// find all preview images and remove the skeleton from the parent
							if (sliderEl) {
								const previewImages = html.querySelectorAll<HTMLImageElement>(sliderEl, '.technical-preview-img');
								previewImages.forEach(img => {
									const removeSkeleton = () => {
										const parent = html.getParentWithClassName(img, "skeleton-loading");
										if (parent) parent.classList.remove("skeleton-loading");
									};

									if (img.complete) {
										removeSkeleton();
									} else {
										img.addEventListener('load', () => { removeSkeleton(); });
									}
								});
							}
						},
						// height script buttons
						SliderCreated: (settings, slider, Slider) => { return; },
					} as eXpress.components.main.ICustomPhotoSliderWithDivSettings;

					const sliderComponent = eXpress.components.main.createCustomSlider(slider, sliderSettings);
					sliderComponents.push({ key: dialogId, slider: sliderComponent });
					dialog.openAsync();
				}));
		};

		const deleteCartProductConfirmationPopup = (id: string, doneCallback: (res: eXpress.components.checkout.ICartUxActionResult) => void, replacements?: string) => {
			// prevent user from opening multiple popups at the same time by double click
			if (popupConfirmDeleteIsOpen) return;
			popupConfirmDeleteIsOpen = true;

			let dialog: core.StyleguideViewPopup;
			eXpress.core.StyleguideViewPopup.createDialogAsync(
				{
					view: "ConfirmDialogUX",
					dialogId: "cart-delete",
					forceRefresh: true
				},
				{
					title: 'Label.CartDeleteItem.PageTitle',
					question: 'Label.CartDeleteItem.ItemDescription',
					replacements: replacements,
					okmnemonic: 'Label.DeleteButtonText',
					cancelmnemonic: 'Label.MyPages.Contacts.DeleteConfirm.Cancel'
				}
			)
				.then($popup => {
					popupConfirmDeleteIsOpen = false;
					components.checkout.createRemoveConfirmation(
						$popup[0],
						{
							onRemoveConfirm: (remove?: boolean) => {
								if (remove)
									return deleteCartProduct(id).then((res: eXpress.components.checkout.ICartUxActionResult) => {
										doneCallback(res);
										dialog.close(true);
										// because the pop up is still open the client does not scroll to the top message on doneCallback
										pageLogComponent.scrollTo();
									});
								else {
									dialog.close(remove || false);
									return $.Deferred<void>().resolve().promise();
								}
							}
						}
					);

					dialog = new core.StyleguideViewPopup($popup);
					dialog.openAsync();
				});
		};

		const changeQuantity = (id: string, quantity: number) => {
			return actions(undefined, undefined, id, quantity);
		};
		const cartContainerEl = html.querySelector<HTMLElement>(document, '.technical-shopping-cart-container-element', true);
		const cartProductTilesEl = html.querySelector<HTMLElement>(cartContainerEl, '.technical-cart', false); // if this does not exist => shopping cart is empty
		let discountEl: HTMLElement | null;
		if (cartProductTilesEl) {
			// The mini basket
			const rightContainerEl = html.querySelector<HTMLElement>(document, '.technical-right-column', true);
			const miniBasketEl = html.querySelector<HTMLElement>(rightContainerEl, '.technical-mini-shoppingcart', true);
			const miniBasket = new eXpress.components.checkout.MiniBasket(miniBasketEl, { refreshMiniBasketApi: refreshMiniBasket });

			// The discount area
			const collapsableInfos: { el: HTMLElement, collapsableSelector: string, titleSelector: string, collapsable: components.main.ICollapsable | undefined, shouldReopen: boolean }[] = [];

			const discountInputCollapse = html.querySelector<HTMLElement>(rightContainerEl, '.technical-discount-input-collapsable');
			discountInputCollapse && collapsableInfos.push({ el: discountInputCollapse, collapsableSelector: '.technical-discount-input-collapsable', titleSelector: '.technical-collapsable-title', collapsable: undefined, shouldReopen: false });

			collapsableInfos.forEach(c => {
				if (c.el) {
					c.collapsable?.dispose();
					c.collapsable = components.main.createCollapsable(c.el, { titleElSelector: c.titleSelector, scrollIntoViewAfterOpen: false });
					if (c.shouldReopen) c.collapsable.open();
				}
			});

			discountEl = html.querySelector<HTMLElement>(rightContainerEl, '.technical-discount', false);
			let discount: eXpress.components.checkout.IDiscount;
			if (discountEl)
				discount = components.checkout.createDiscount(discountEl, { refreshMiniBasket: (overrideMiniBasketHtml?: string) => miniBasket.refreshServerSide(overrideMiniBasketHtml), changePromoCode: changePromoCode });

			// The continue button
			const continueButtonEls = html.querySelectorAll<HTMLElement>(document, '.technical-checkout-step-confirm-button');

			// The actual products
			components.checkout.createCartProductTiles(cartContainerEl, cartProductTilesEl,
				{
					refreshMiniBasket: (overrideMiniBasketHtml?: string) => miniBasket.refreshServerSide(overrideMiniBasketHtml),
					deleteCartProduct: deleteCartProductConfirmationPopup,
					changeQuantity,
					refreshDiscount: (newContent: string) => discount.refreshServerSide(newContent),
					refreshContinueButton: (newContent: string) => {
						continueButtonEls.forEach((i) => {
							const node = html.htmlToElement(newContent);
							if (node) {
								i.replaceWith(node);
								i = node as HTMLElement;
							}
						});
						addContinueButtonHandlers();
					},
					previewPopup
				});
		}

		/* The cart, before going to the next step, has to check minimum ordered quantities */
		const addContinueButtonHandlers = () => {
			const nextButtons = html.querySelectorAll(document, ".technical-checkout-step-confirm-button");
			const onNextButtonClick = (event: Event) => {
				const message = (<HTMLElement>event.currentTarget).dataset['productminimum'] || (<HTMLElement>event.currentTarget).dataset['productmaximum'];
				if (message) {
					event.preventDefault();
					pageLogComponent.updateMessageAndStyle(components.main.PageLogStyle.Error, message, true); // make sure that the client scrolls to the error message
					return;
				}

				if (gtmData) {
					window.dataLayer = window.dataLayer || [];
					window.dataLayer.push(JSON.parse(gtmData));
				}
			};
			if (nextButtons) nextButtons.forEach((nextButton) => html.addEventListener(nextButton, "click", onNextButtonClick));
		};
		addContinueButtonHandlers();

		const inPageRecommendationsEl = html.querySelector<HTMLElement>(document, '.technical-in-page-recommendations-container', false);
		if (inPageRecommendationsEl) {
			const inPageSliderEl = html.querySelector<HTMLElement>(inPageRecommendationsEl, '.technical-slider', true);
			const pageType = inPageRecommendationsEl.dataset.pagetype || '';
			const pageCode = inPageRecommendationsEl.dataset.pagecode || '';
			initSlider(inPageSliderEl, pageType, pageCode);
		}

		const sameDesignsSliders = html.querySelectorAll(document, '.technical-samedesignsslider-slider');
		sameDesignsSliders.forEach((sameDesignsSlider) => {
			const sliderElements: eXpress.components.main.ICustomPhotoSliderItem[] = [];
			for (let z = 0, l = sameDesignsSlider.children.length; z < l; z++) {
				const slideEl = sameDesignsSlider.children[z] as HTMLElement;
				sliderElements.push({ template: slideEl });
			}

			const settings: eXpress.components.main.ICustomPhotoSliderWithDivSettings = {
				sliderElements: sliderElements,
				sliderContainerSettings: {
					extraSliderClass: 'm-product-slider__slider-container',
					elementsContainerSettings: {
						extraSliderClass: 'm-product-slider__slider-content',
						slideClicked: () => { return; }
					},
					nextButton: {
						cssWhenOnMax: 'a-button--disabled',
						onClick: () => { return; }
					},
					previousButton: {
						cssWhenOnMax: 'a-button--disabled',
						onClick: () => { return; }
					},
				},
				showHalfSlides: false,
				replaceWithElement: true,
				enableEternalSliding: true,
				eternalSlidingMode: eXpress.components.main.EternalSlidingMode.Infinite,
				translateForMovement: true,
			};

			if (sameDesignsSlider.parentElement)
				eXpress.components.main.createCustomSlider(sameDesignsSlider.parentElement, settings);
		});
	});

	// Expose the initSlider to GTM through the dataLayer
	const initSlider = (sliderEl: HTMLElement, pageType: string, pageCode: string, epc?: string): void => {
		// convert so slider elements
		const sliderElements: eXpress.components.main.ICustomPhotoSliderItem[] = [];

		for (let z = 0, l = sliderEl.children.length; z < l; z++) {
			const slideEl = sliderEl.children[z] as HTMLElement;
			if (epc) {
				const link = html.querySelector<HTMLAnchorElement>(slideEl, "a", false);
				if (link) {
					link.href = utils.updateParameter("epc", epc, link.href);
				}
			}
			sliderElements.push({ template: slideEl });
		}

		// set height of buttons
		const heightScriptButtons = (slider: HTMLElement, bottomTitleHeight: number, highestSlideEl: HTMLElement) => {
			// BUTTONS
			const sliderButtons = html.querySelectorAll(slider, '.technical-slider-button');
			const hightestImage = html.querySelector<HTMLElement>(highestSlideEl, '.m-product__content-container', false);
			let buttonCenterImage = 0;
			if (hightestImage) {
				if (bottomTitleHeight === 0) {
					const infoEls = html.querySelectorAll<HTMLElement>(slider, '.technical-info-content-items');
					if (infoEls && infoEls.length > 0) {
						infoEls.forEach(infoEl => {
							const infoElHeight = html.getHeightWithMargins(infoEl);
							if (infoEl && infoElHeight > bottomTitleHeight) bottomTitleHeight = infoElHeight;
						});
					}
				}
				buttonCenterImage = (hightestImage.offsetHeight / 2) + bottomTitleHeight - 17;
			}

			for (let i = 0, l = sliderButtons.length; i < l; i++) {
				(sliderButtons[i] as HTMLElement).style.bottom = `${buttonCenterImage > 0 ? buttonCenterImage : (highestSlideEl.offsetHeight / 2)}px`;
			}
		};

		// gets the highest slide element in the slider elements
		const getHighestSlideOfSlider = (slidesInSlider: HTMLElement[]): HTMLElement => {
			let highestSlideEl: HTMLElement;
			let maxHeight = 0;

			for (let i = slidesInSlider.length - 1; i >= 0; i--) {
				const slideEl = slidesInSlider[i] as HTMLElement;

				const slideHeight = html.getHeightWithMargins(slideEl);

				if (maxHeight <= slideHeight) {
					maxHeight = slideHeight;
					highestSlideEl = slideEl;
				}
			}

			return highestSlideEl!;
		};
		const trackedSliderElIds: string[] = [];
		const addClickEventsToSliderEls = (sliderElements: HTMLElement[], pageType: string, pageCode: string) => {
			const onClickEvent = (ev: Event) => {
				const currentEl = ev.currentTarget as HTMLElement;
				const anchorEls = eXpress.html.querySelectorAll<HTMLAnchorElement>(currentEl, 'a');
				const label = {
					pageType: pageType,
					pageCode: pageCode,
					pvc: eXpress.utils.getParameter('pvc', anchorEls[0].href, false) || ''
				} as eXpress.analytics.ICartRecommendationEventParams;
				eXpress.analytics.trackRecommendationCartEvent("Recommended product clicked", label);
			};

			sliderElements.forEach(el => {
				if (trackedSliderElIds.find(id => id === el.id)) return;
				trackedSliderElIds.push(el.id);
				eXpress.html.addEventListener(el, 'click', onClickEvent);
			});
		};

		// settings for slider
		const settings: eXpress.components.main.ICustomPhotoSliderWithDivSettings = {
			sliderElements: sliderElements,
			sliderContainerSettings: {
				extraSliderClass: 'm-product-slider__slider-container',
				elementsContainerSettings: {
					extraSliderClass: 'm-product-slider__slider-content',
					slideClicked: () => { return; }
				},
				nextButton: {
					cssWhenOnMax: 'a-button--disabled',
					onClick: () => { return; }
				},
				previousButton: {
					cssWhenOnMax: 'a-button--disabled',
					onClick: () => { return; }
				},
			},
			showHalfSlides: false,
			replaceWithElement: true,
			enableEternalSliding: true,
			eternalSlidingMode: eXpress.components.main.EternalSlidingMode.Infinite,
			translateForMovement: true,

			InitializedEvent: (settings, sliderEl) => {
				const visibleSlides = html.querySelectorAll(sliderEl, '.technical-slide') as HTMLElement[];
				addClickEventsToSliderEls(visibleSlides, pageType, pageCode);
			},

			// height script buttons
			SliderCreated: (settings, slider, Slider) => {
				// slider elements are on the DOM
				const visibleSlides = html.querySelectorAll(Slider ? Slider : sliderEl, '.technical-slide') as HTMLElement[];

				// new slider elements that has not been added to the DOM yet
				// Do this for the height script => minimize flicker, drag, slide, ... of elements when slider is on DOM
				const highestSlideEl = getHighestSlideOfSlider(visibleSlides);
				const highestSlideLinkTextEl = html.querySelectorAll(highestSlideEl, '.technical-tile-link-text') as HTMLElement[];
				const highestSlideLinkTextpx = highestSlideLinkTextEl.length > 0 ? html.getHeightWithMargins(highestSlideLinkTextEl[0]) : 0;

				heightScriptButtons(slider, highestSlideLinkTextpx, highestSlideEl);
			},
			ResizeEvent: (settings, slider) => {
				const visibleSlides = html.querySelectorAll(slider, '.technical-slide') as HTMLElement[];
				const highestSlideEl = getHighestSlideOfSlider(visibleSlides);
				const highestSlideLinkTextEl = html.querySelectorAll(highestSlideEl, '.technical-tile-link-text') as HTMLElement[];
				const highestSlideLinkTextpx = highestSlideLinkTextEl.length > 0 ? html.getHeightWithMargins(highestSlideLinkTextEl[0]) : 0;

				heightScriptButtons(slider, highestSlideLinkTextpx, highestSlideEl);
				addClickEventsToSliderEls(visibleSlides, pageType, pageCode);
			}
		};

		// create slider
		if (sliderEl.parentElement)
			eXpress.components.main.createCustomSlider(sliderEl.parentElement, settings);
	};
	window.initSlider = initSlider;

	// fix for buttons overlay with each other => WEB-8828
	const resizeElementForButtonOverlay = () => {
		const cartContainerEl = html.querySelector<HTMLElement>(document, '.technical-shopping-cart-container-element', false);
		const recommendations = html.querySelector<HTMLElement>(document, '.technical-in-page-recommendations-container', false);
		const continueButtonEl = html.querySelector<HTMLElement>(document, '.technical-checkout-step-continue', false);
		if (continueButtonEl && (recommendations || cartContainerEl)) {
			(recommendations || cartContainerEl)!.style.marginBottom = !html.isMobile() ? '' : `${continueButtonEl.offsetHeight - 8}px`;
		}
	};
	resizeElementForButtonOverlay();
	window.addEventListener('resize', resizeElementForButtonOverlay);

	// Fallback for the Emarsys Recommendations
	const recommendationsEl = html.querySelector<HTMLElement>(document, '.technical-emarsys-recommendation', false);
	if (recommendationsEl) {
		utils.createGtmMutationObserver(recommendationsEl, 2)
			.catch((err) => {
				const fallbackRecommendationsEl = html.querySelector<HTMLElement>(document, '.technical-recommendations-fallback-slider', false);
				if (fallbackRecommendationsEl) {
					const sliderContentKey = fallbackRecommendationsEl.dataset.contentkey || '';
					if (sliderContentKey) {
						utils.getHtmlRequest(`/apicore/componentapi/productslider?contentkey=${sliderContentKey}&isprospect=false&showcurrency=true`, { headers: new Headers({'Content-type': 'application/json; charset=utf-8'}) })
							.then(r => {
								const elementHtml = document.createRange().createContextualFragment(r);
								fallbackRecommendationsEl.appendChild(elementHtml);
								const productSliderModuleEl = html.querySelector<HTMLElement>(fallbackRecommendationsEl, '.m-product-slider', true);
								html.addClass(productSliderModuleEl, 'm-product-slider--below-shoppingcart');
								const fallbackSliderEl = html.querySelector<HTMLElement>(fallbackRecommendationsEl, '.technical-slider', false);
								if (fallbackSliderEl) {
									html.removeClass(fallbackRecommendationsEl, 'u-hide');
									initSlider(fallbackSliderEl, 'cart', 'Cart');
								}
							});
					}
				}
			});
	}
}
